// Back and Next at the foot of the card (Isomorphic's multi-step Navigator). Next is disabled
// while the step is incomplete, with the reason beside it rather than an error after a click.
import { ArrowLeft, ArrowRight, Check } from "@phosphor-icons/react";
import { Button } from "rizzui";

import { useT } from "../../../i18n";
import { cn } from "../../../ui/cn";

interface Props {
  first: boolean;
  last: boolean;
  blocked: string | null;
  busy?: boolean;
  onBack: () => void;
  onNext: () => void;
  /** The last step's button (default "Create task group"). */
  finishLabel?: string;
}

export function Navigator({ first, last, blocked, busy, onBack, onNext, finishLabel }: Props) {
  const t = useT().tasks.create;
  return (
    <div className="mt-8 flex flex-wrap items-center gap-3 border-t border-muted pt-5 md:mt-10">
      {!first ? (
        <Button variant="outline" size="lg" className="gap-1.5" onClick={onBack} disabled={busy}>
          <ArrowLeft className="h-4 w-4" aria-hidden /> {t.back}
        </Button>
      ) : null}
      <p className={cn("order-first m-0 w-full min-w-0 text-[13px] text-gray-500 sm:order-none sm:block sm:w-auto sm:flex-1 sm:text-end", !blocked && "hidden")} aria-live="polite">
        {blocked}
      </p>
      <Button size="lg" className="ms-auto gap-1.5" onClick={onNext} disabled={blocked !== null || busy} isLoading={busy}>
        {last ? (
          <>
            <Check weight="bold" className="h-4 w-4" aria-hidden /> {finishLabel ?? t.create}
          </>
        ) : (
          <>
            {t.next} <ArrowRight className="h-4 w-4" aria-hidden />
          </>
        )}
      </Button>
    </div>
  );
}
